import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import NotificationAlert from 'react-notification-alert'
import axios from 'axios'
import Cookies from 'js-cookie'
import moment from 'moment'

import * as constants from 'constants/index.js'
import CardsHeader from 'layouts/Headers/CardsHeader.js'

import TableCustom from 'views/pages/components/TableCustom'

import BookModal from 'views/pages/components/BookModal'

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Modal,
} from 'reactstrap'

import {
  hasPermission
} from 'views/policies/FleetPolicy';

export default function TypeInspect() {
  const { type } = useParams()
  const notificationAlert = useRef(null)
  const history = useHistory()
  const location = useLocation()
  
  const permissions = useSelector(state => state.getState).permissions
  const profileData = useSelector(state => state.getState).profileData

  const [token, setToken] = useState('')
  const [loading, setLoading] = useState(true)
  const [jobs, setJobs] = useState([])
  const [pagination, setPagination] = useState('')
  const [filter, setFilter] = useState('')
  const [statusTypes, setStatusTypes] = useState('')
  const [jobTypes, setJobTypes] = useState([])
  const [dealerMembers, setDealerMembers] = useState([])

  const [bookModal, setBookModal] = useState({
    show: false,
    header: ''
  })
  const [errors, setErrors] = useState('')
  const [job, setJob ] = useState('')

  const [confirmModal, setConfirmModal] = useState({
    show: false,
    header: '',
    body: '',
  })

  const notify = (type, header, message) => {
    const options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {header}
          </span>
          <span data-notify="message">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5
    }
    notificationAlert.current.notificationAlert(options)
  }

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    fetchData(1, source, grs_token, '')

    return () => {
      source.cancel()
    }
  }, [])

  const fetchData = async (pageNumber, source, token, filter) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${constants.API_URL}/fleet-management/jobs-by-type`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          ...filter,
          page: pageNumber,
          jobType: type
        },
        cancelToken: source.token,
      })
      console.log('response :: ', response.data)
      const data = response.data
      setJobs(data.data.jobs.data)
      setPagination(data.data.jobs)
      let _status_types = data.data.statusTypes
      let _statusTypes = []
      _status_types.map((type, index) => {
        _statusTypes.push({
          id: index,
          name: type
        })
      })
      setStatusTypes(_statusTypes)
      setJobTypes(data.data.jobTypes)
      setDealerMembers(data.data.dealerMembers)

      setLoading(false)
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request canceled :: ', error)
      } else {
        console.error('error :: ', error)
        notify('warning', 'Warning', error.response ? error.response.statusText : 'Error occurred!')
      }
    }
  }

  const goList = () => {
    history.push({
      pathname: `/admin/fleet-job/dashboard/${location.state.category}`
    })
  }

  const bookJob = async (job) => {
    try {
      const response = await axios({
        method: 'PUT',
        url: `${constants.API_URL}/fleet-management/${type}/type-jobs/${job.uuid}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...job,
          end_date: job.end_date ? job.end_date : job.status == 2 ? moment().format('YYYY-MM-DDTHH:mm:ss') : '',
        }
      })
      console.log('response :: ', response.data)
      const data = response.data
      setJobs(data.data.jobs.data)
      setPagination(data.data.jobs)

      notify('success', 'Success', data.message)
      setBookModal({
        ...bookModal,
        show: false
      })
      setConfirmModal({
        ...confirmModal,
        show: false
      })
    } catch (error) {
      console.error('error :: ', error)
      if (error.response && error.response.status === 422) {
        setErrors(error.response.data.errors)
        return
      }
      setBookModal({
        ...bookModal,
        show: false
      })
      setConfirmModal({
        ...confirmModal,
        show: false
      })
      notify('warning', 'Warning', error.response ? error.response.statusText : 'Error occurred!')
    }
  }

  const editJob = (row) => {
    setJob({
      ...row,
      estimated_completion_at: row.estimated_completion_at ? moment(row.estimated_completion_at).format('YYYY-MM-DDTHH:mm:ss') : '',
      start_date: row.start_date ? moment(row.start_date).format('YYYY-MM-DDTHH:mm:ss') : '',
      end_date: row.end_date ? moment(row.end_date).format('YYYY-MM-DDTHH:mm:ss') : '',
    })
    setBookModal({
      show: true,
      header: row.booked_by ? 'Complete a job' : 'Start a job'
    })
  }

  const changeJobStatus = (row) => {
    setJob({
      ...row,
      status: 2,
      end_date: moment().format('YYYY-MM-DDTHH:mm:ss'),
    })

    setConfirmModal({
      ...confirmModal,
      show: true,
      header: 'Complete a Job',
      body: 'Are you sure you want to mark as completed this job?'
    })
  }

  return (
    <>
      <CardsHeader name="Leads" parentName="Leads Management" currentName="Create" />
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
				        <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Book In Page</h1>
                    <p className="text-sm mb-0">You can book a job here.</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    <Button className="w-100" color="success" type="button" onClick={() => goList()}>Back to dashboard</Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom 
                  loading={loading}
                  items={jobs}
                  pagination={pagination}
                  onChange={pageNumber => fetchData(pageNumber, axios.CancelToken.source(), token, filter)}
                  columns={[
                    {
                      dataField: "name",
                      text: "Type of work",
                    },
                    {
                      dataField: "description",
                      text: "Work needed"
                    },
                    {
                      dataField: "reg_no",
                      text: "Reg No",
                      formatter: (rowContent, row) => {
                        return row.vehicle? row.vehicle.stock_no: ''
                      }
                    },
                    {
                      dataField: "eta_hours",
                      text: "ETA Hours"
                    },
                    {
                      dataField: "estimated_completion_at",
                      text: "Estimated Completion Date",
                      formatter: (rowContent, row) => {
                        return row.estimated_completion_at? constants.formatDateShortGB(row.estimated_completion_at): ''
                      }
                    },
                    {
                      dataField: "status",
                      text: "Status",
                      formatter: (rowContent, row) => {
                        if (row.start_date && row.booked_by && row.status === 1) {
                          return `In progress from ${constants.formatDateShortGB(row.start_date)}`
                        } else if (row.start_date && row.booked_by && row.end_date && row.status === 2) {
                          return statusTypes? `${statusTypes[row.status].name} in ${constants.formatDateShortGB(row.end_date)}`: ''
                        } else {
                          return statusTypes? statusTypes[row.status].name: ''
                        }
                      }
                    },
                    {
                      dataField: "",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            {hasPermission(permissions, 'update-fleet-management') &&
                              row.status !== 2 && 
                              <Button className="fleet-table-button" color="success" type="button" onClick={() => {
                                setErrors('')
                                editJob(row)
                              }}>
                                {`Edit`}
                              </Button>
                            }
                            {!hasPermission(permissions, 'update-fleet-management') &&
                              (row.status !== 2 && row.booked_by && row.booked_by === profileData.id) &&
                              <Button className="fleet-table-button" color="success" type="button" onClick={() => changeJobStatus(row)}>
                                {`Mark As Completed`}
                              </Button>
                            }
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <BookModal 
          bookModal={bookModal}
          setBookModal={setBookModal}
          jobTypes={jobTypes}
          job={job}
          setJob={setJob}
          errors={errors}
          statusTypes={statusTypes}
          dealerMembers={dealerMembers}
          bookJob={() => bookJob(job)}
        />
        <Modal
          isOpen={confirmModal.show}
          toggle={() => setConfirmModal({
            ...confirmModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title">{confirmModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setConfirmModal({
                ...confirmModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {confirmModal.body}
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="primary"
              type="button"
              onClick={() => bookJob(job)}
            >
              {`Confirm`}
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setConfirmModal({
                ...confirmModal,
                show: false
              })}
            >
              {`Close`}
            </Button>
          </div>
        </Modal>
      </Container>
    </>
  )
}